import { FC, useContext, useEffect, useState } from "react";
import { useIdleTimer } from "react-idle-timer";

import useLogout from "../../hooks/useLogout";
import { ToastContext } from "src/context/toastContext";
import { ToastTypes } from "src/types";
import { formatTime } from "src/helpers/session";




const IdleSession: FC<{ idleTime: number }> = ({ idleTime }) => {
  const [isSessionExpired, changeSessionExpiryStatus] = useState<boolean>(false)
  const [remainingTime, updateRemainingTime] = useState<string>("")

  const { logoutUser } = useLogout()
  const { showToast } = useContext(ToastContext)

  const onIdleAction = () => {
    changeSessionExpiryStatus(true);
  }

  const onActiveAction = () => {
    if (isSessionExpired) {
      changeSessionExpiryStatus(false);
      showToast(["Your session has expired. Please login again to continue"], ToastTypes.ERROR);
      logoutUser(true);
    }
  }

  const { getRemainingTime } = useIdleTimer({
    timeout: idleTime <= 0 ? 1 : idleTime,
    throttle: 500,
    crossTab: true,
    startOnMount: true,
    startManually: false,
    onActive: () => onActiveAction(),
    onIdle: () => onIdleAction(),
  });

  useEffect(() => {
    const storeCurrentTimeInLC = () => {
      localStorage.setItem("momentTimeLogged", new Date().toString())
    }

    const timer = setInterval(() => {
      updateRemainingTime(formatTime(getRemainingTime()))
    }, 1000)

    window.addEventListener("beforeunload", storeCurrentTimeInLC)
    return () => {
      // console.log("Component is unmounting!!!!")
      window.removeEventListener("beforeunload", storeCurrentTimeInLC)
      clearInterval(timer)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <></>;
  // return <p className="h1">{remainingTime}</p>;
}

export default IdleSession;
